import * as React from "react"
import { useState, useContext } from "react"
import Section from "../../../../core/layout/main/section/Section"
import * as classNames from "./RhJobAdResultsSection.module.scss"
import Card from "../../../common/blocks/card/Card"
import Icon from "../../../common/blocks/icon/Icon"
import SearchField from "../Component/SearchField"
import SearchCityField from "../Component/SearchCityField"
import TypeContractSideFiltre from "../Component/TypeContractSideFiltre"
import MyContext from "../Component/MyContext"
import Button from "../../../common/blocks/button/Button"
import CardDetails from "../../../common/blocks/card/CardDetails"
import { navigate } from "gatsby"
const RhJobAdResultsSection = ({
  CardTitle,
  CardDescription,
  CardBoutonText,
}) => {
  const [showSuggestionPoste, setShowSuggestionPoste] = useState(false)
  const [showSuggestionLocation, setShowSuggestionLocation] = useState(false)
  const [showSuggestionContract, setShowSuggestionContract] = useState(false)
  const [filtredItems, setFiltredItems] = useState([])
  const [name, setName] = useState("")
  // function handleToggle(index) {
  //   setActiveIndex(index === activeIndex ? null : index)
  //   ![...activeIndexListe].includes(index)
  //     ? setActiveIndexListe([...activeIndexListe, index])
  //     : setActiveIndexListe([...activeIndexListe].filter((el) => el !== index))
  // }


  return (
    <Section
      container={"large"}
      className={classNames.RhJobAdSearchFormSection}
    >
      <div className={classNames.gridContainer}>
        <div className={classNames.filtres}>
          <CardDetails
            title="Poste"
            isOpen
          >
            <div className="mt-3">
              {showSuggestionPoste && (
                <SearchField
                  filtredItems={filtredItems}
                  setFiltredItems={setFiltredItems}
                  name={name}
                  setName={setName}
                />
              )}
              <div className="tags mt-3">
                <Button
                  aspect="tag"
                  size="large"
                  color="primary"
                  className="icon"
                  onClick={() =>
                    showSuggestionPoste
                      ? setShowSuggestionPoste(false)
                      : setShowSuggestionPoste(true)
                  }
                >
                  <Icon
                    icon="add"
                    color="secondary"
                    width="41"
                    height="41"
                  />
                </Button>
              </div>
            </div>
          </CardDetails>
          <CardDetails
            title="Régions"
            isOpen
          >
            <div className="mt-3">
              {showSuggestionLocation && (
                <SearchCityField
                  classe={`pb-2`}
                  filtredItems={filtredItems}
                  setFiltredItems={setFiltredItems}
                  name={name}
                  setName={setName}
                />
              )}
              <div className="tags mt-3">
                <Button
                  aspect="tag"
                  size="large"
                  color="primary"
                  className="icon"
                  onClick={() =>
                    showSuggestionLocation
                      ? setShowSuggestionLocation(false)
                      : setShowSuggestionLocation(true)
                  }
                >
                  <Icon
                    icon="add"
                    color="secondary"
                    width="41"
                    height="41"
                  />
                </Button>
              </div>
            </div>
          </CardDetails>
          <CardDetails
            title="Contrat"
            isOpen
          >
            <div className="mt-3">
              <div className="tags mt-3">
                {showSuggestionContract && <TypeContractSideFiltre />}
                <Button
                  aspect="tag"
                  size="large"
                  color="primary"
                  className="icon"
                  onClick={() =>
                    showSuggestionContract
                      ? setShowSuggestionContract(false)
                      : setShowSuggestionContract(true)
                  }
                >
                  <Icon
                    icon="add"
                    color="secondary"
                    width="41"
                    height="41"
                  />
                </Button>
              </div>
            </div>
          </CardDetails>
          <Card className="quartary-background-color no-shadow flex flex-direction-column align-items-center text-center p-3 gap-3">
            <p className="fs-20">
              {CardTitle ? CardTitle : "Candidature spontanée"}
            </p>
            <p>
              {CardDescription
                ? CardDescription
                : `Paritel est à la recherche de personnes talentueuses, n'hésitez<br/>pas à laisser votre CV !`}
            </p>
            <Button
              aspect="classique"
              size="medium"
              color="primary"
              onClick={()=> {
                navigate('/pop-in/candidature-1', {
                  state: {
                    modal: true,
                  },
                })
              }}
              className="m-auto"
            >
              {CardBoutonText ? CardBoutonText : "Déposer mon CV"}
            </Button>
          </Card>
        </div>
        <div className={classNames.results}>
          <Card
            type="annonce"
            className="quinary-background-color no-shadow p-3"
          >
            <div className="card__header flex align-items-center mb-3">
              <div className="card__header__title">
                <p className="fs-24">
                  Commercial New Business (H/F)
                  {/* {jobAd.attributes.title} */}
                </p>
              </div>
              <span className="ml-auto quartary-text-color">
                Il y a 3 jours
              </span>
            </div>
            <div className="card__content"></div>
            <div className="card__footer flex align-items-center justify-content-space-between mt-auto">
              <div className="tags">
                <Button
                  aspect="tag"
                  color="primary"
                  size="large"
                >
                  Bois-Colombes
                  {/* {jobAd.attributes.agence.data?.attributes.city} */}
                </Button>
                <Button
                  aspect="tag"
                  color="primary"
                  size="large"
                >
                  Commerce
                </Button>
                <Button
                  aspect="tag"
                  color="primary"
                  size="large"
                >
                  CDI
                  {/* {jobAd.attributes.agence.data?.attributes.city} */}
                </Button>
                {/* {jobAd.attributes.criterias.data.map((critere, j) => {
                  if (critere.attributes.type === "Type_de_contrat") {
                    return (
                      <Button
                        key={j}
                        aspect="tag"
                        color="primary"
                        size="large"
                      >
                        {critere.attributes.value}
                      </Button>
                    );
                  } else {
                    return null;
                  }
                })} */}
              </div>
              <Button
                aspect={"contrastant"}
                color={"primary"}
                size={"large"}
                // to={'/annonces/' + jobAd.attributes.slug}
              >
                Postuler
              </Button>
            </div>
          </Card>
          <Card
            type="annonce"
            className="quinary-background-color no-shadow p-3"
          >
            <div className="card__header flex align-items-center mb-3">
              <div className="card__header__title">
                <p className="fs-24">
                  Commercial New Business (H/F)
                  {/* {jobAd.attributes.title} */}
                </p>
              </div>
              <span className="ml-auto quartary-text-color">
                Il y a 3 jours
              </span>
            </div>
            <div className="card__content"></div>
            <div className="card__footer flex align-items-center justify-content-space-between mt-auto">
              <div className="tags">
                <Button
                  aspect="tag"
                  color="primary"
                  size="large"
                >
                  Bois-Colombes
                  {/* {jobAd.attributes.agence.data?.attributes.city} */}
                </Button>
                <Button
                  aspect="tag"
                  color="primary"
                  size="large"
                >
                  Commerce
                </Button>
                <Button
                  aspect="tag"
                  color="primary"
                  size="large"
                >
                  CDI
                  {/* {jobAd.attributes.agence.data?.attributes.city} */}
                </Button>
                {/* {jobAd.attributes.criterias.data.map((critere, j) => {
                  if (critere.attributes.type === "Type_de_contrat") {
                    return (
                      <Button
                        key={j}
                        aspect="tag"
                        color="primary"
                        size="large"
                      >
                        {critere.attributes.value}
                      </Button>
                    );
                  } else {
                    return null;
                  }
                })} */}
              </div>
              <Button
                aspect={"contrastant"}
                color={"primary"}
                size={"large"}
                // to={'/annonces/' + jobAd.attributes.slug}
              >
                Postuler
              </Button>
            </div>
          </Card>
          <Card
            type="annonce"
            className="quinary-background-color no-shadow p-3"
          >
            <div className="card__header flex align-items-center mb-3">
              <div className="card__header__title">
                <p className="fs-24">
                  Commercial New Business (H/F)
                  {/* {jobAd.attributes.title} */}
                </p>
              </div>
              <span className="ml-auto quartary-text-color">
                Il y a 3 jours
              </span>
            </div>
            <div className="card__content"></div>
            <div className="card__footer flex align-items-center justify-content-space-between mt-auto">
              <div className="tags">
                <Button
                  aspect="tag"
                  color="primary"
                  size="large"
                >
                  Bois-Colombes
                  {/* {jobAd.attributes.agence.data?.attributes.city} */}
                </Button>
                <Button
                  aspect="tag"
                  color="primary"
                  size="large"
                >
                  Commerce
                </Button>
                <Button
                  aspect="tag"
                  color="primary"
                  size="large"
                >
                  CDI
                  {/* {jobAd.attributes.agence.data?.attributes.city} */}
                </Button>
                {/* {jobAd.attributes.criterias.data.map((critere, j) => {
                  if (critere.attributes.type === "Type_de_contrat") {
                    return (
                      <Button
                        key={j}
                        aspect="tag"
                        color="primary"
                        size="large"
                      >
                        {critere.attributes.value}
                      </Button>
                    );
                  } else {
                    return null;
                  }
                })} */}
              </div>
              <Button
                aspect={"contrastant"}
                color={"primary"}
                size={"large"}
                // to={'/annonces/' + jobAd.attributes.slug}
              >
                Postuler
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </Section>
  )
}

export const name = "RhJobAdResultsSection"

export const init = (componentData, pageContext) => {
  return (
    <RhJobAdResultsSection
      key={componentData.id}
      poste={componentData.TitleTab1}
      localisation={componentData.TitleTab2}
      contract={componentData.TitleTab3}
      CardTitle={componentData.Card?.CardTitle}
      CardDescription={componentData.Card?.CardDescription}
      CardBoutonText={componentData.Card?.CardBouton.text}
    />
  )
}

export default RhJobAdResultsSection
